<div>
  <!-- Dropdown Menu -->
  <label for="options">Select an option:</label>
  <select id="options" [(ngModel)]="selectedOption" (change)="onOptionChange()">
    <option value="" selected>Select an option</option> <!-- Empty option -->
    <option *ngFor="let option of options" [value]="option.value">{{ option.label }}</option>
  </select>
</div>

<div>
  <!-- Description Text -->
  <p>{{ descriptionText }}</p>
</div>

<div>
  <!-- Search Input -->
  <input
    type="text"
    placeholder="Search..."
    [disabled]="!isSearchEnabled"
    [(ngModel)]="searchQuery"
  />
  <button [disabled]="!isSearchEnabled" (click)="onSearch()">Search</button> <!-- Search Button -->
</div>

<div class="tracking-section">
  <h2>Update Tracking (Top 5 Most Recent)</h2>
  
  <div *ngIf="isLoadingTracking" class="loading">Loading tracking data...</div>
  
  <div *ngIf="!isLoadingTracking && trackingData.length > 0" class="table-wrapper">
    <table class="tracking-table">
      <thead>
        <tr>
          <th>Started At</th>
          <th>Ended At</th>
          <th>Row Count</th>
          <th>Endpoint Version</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of trackingData">
          <td>{{ record.started_at | date:'short' }}</td>
          <td>{{ record.ended_at | date:'short' }}</td>
          <td>{{ record.row_count }}</td>
          <td>{{ record.endpoint_version }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <div *ngIf="!isLoadingTracking && trackingData.length === 0" class="no-data">
    No tracking data available.
  </div>
</div>

<div class="tracking-section">
  <h2>Error Tracking (Top 5 Most Recent)</h2>
  
  <div *ngIf="isLoadingErrors" class="loading">Loading error data...</div>
  
  <div *ngIf="!isLoadingErrors && errorData.length > 0" class="table-wrapper error-table-wrapper">
    <table class="tracking-table">
      <thead>
        <tr>
          <th>Time</th>
          <th>Error</th>
          <th>Endpoint Version</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of errorData">
          <td>{{ record.time | date:'short' }}</td>
          <td>{{ record.error }}</td>
          <td>{{ record.endpoint_version }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <div *ngIf="!isLoadingErrors && errorData.length === 0" class="no-data">
    No error data available.
  </div>
</div>

